/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/errorObject.js
// module id = 679
// module chunks = 0